import { createQuery } from '@/queries/core/createQuery'
import { getAiraVocab, type AiraVocab } from '@/features/aira/api'
import { airaKeys } from './keys'

/** Mirrors the route's `Cache-Control: max-age=3600`. */
const VOCAB_STALE_MS = 60 * 60 * 1000

/** The closed chip lists — public, one fetch an hour for every surface. */
export const useAiraVocabQuery = () =>
  createQuery<AiraVocab>({
    key: airaKeys.vocab(),
    fetcher: async () => {
      const response = await getAiraVocab()
      return response.data
    },
    staleTime: VOCAB_STALE_MS,
    cacheTime: VOCAB_STALE_MS,
  })
